<template>
  <div class="drugCup">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
      <el-form-item label="名称">
        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.name" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="编码">
        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.code" placeholder="请输入"></el-input>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button type="primary" @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
      <el-button type="warning" @click="addItem">新增<i class="el-icon-plus el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          style="width: 100%"
      >
        <el-table-column
            prop="name"
            label="药杯型号名称">
        </el-table-column>
        <el-table-column
            prop="devides"
            label="格数">
        </el-table-column>
        <el-table-column
            prop="code"
            label="药杯型号编码"
            align="center">
        </el-table-column>
        <el-table-column
            prop="note"
            label="备注"
            align="center">
        </el-table-column>
        <el-table-column
            prop="address"
            fixed="right"
            width="150"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="editorClick(scope.row)">编辑</el-button>
<!--            <el-button type="text" size="medium" @click="deleteClick(scope.row.id)">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--    &lt;!&ndash; 分页 &ndash;&gt;-->
    <!--    <div style="margin-top: 20px">-->
    <!--      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'-->
    <!--                  @handleCurrentChange='handleCurrentChange'></Pagination>-->
    <!--    </div>-->
    <el-dialog
        :title="modelTitle"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="20%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="70px" class="demo-ruleForm">
        <el-form-item label="名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="格数" prop="devides">
          <el-input-number v-model="ruleForm.devides" style="width: 100px" :min="1" :max="100" label="描述文字"></el-input-number>
        </el-form-item>
        <el-form-item label="编码">
          <el-input v-model="ruleForm.code" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="ruleForm.note" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";

export default {
  name: "drugCup",
  data() {
    return {
      tableData: [],
      searchForm: {
        name: '',
        code: '',
      },
      modelTitle: '新增药品类型',
      dialogVisible: false,
      ruleForm: {
        name: '',
        code: '',
        note: '',
        devides:0,
      },
      rules: {
        name: [
          {required: true, message: '请输入药杯型号名称', trigger: 'blur'},
        ],
        devides: [
          {required: true, message: '请输入格子数', trigger: 'change'},
        ],
      },
      areaId: '',
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
    }
  },
  components: {
    //someComponent
    Pagination,
  },
  methods: {
    //搜索
    search() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    clear() {
      this.searchForm = {
        name: '',
        code: '',
      }
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    addItem() {
      this.modelTitle = '新增药杯'
      this.ruleForm = {
        name: '',
        code: '',
        note: '',
        devides:0,
      }
      this.dialogVisible = true
    },
    editorClick(row) {
      this.modelTitle = '编辑药杯'
      this.areaId = row.id
      this.ruleForm = {
        name: row.name,
        code: row.code,
        note: row.note,
        devides: row.devides,
      }
      this.dialogVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            ...this.ruleForm,
          }
          if (this.modelTitle === '编辑药杯') {
            this.axios
                .put("api/Cup?id=" + this.areaId, data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible=false
              this.init()
            })
          } else {
            this.axios
                 .post("api/Cup", data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible=false
              this.init()
            })
          }
        } else {
          return false;
        }
      });
    },
    // deleteClick(id) {
    //   let data = {
    //     id: id
    //   }
    //   this.axios
    //        .delete("api/DrugType", {params:data}).then((res) => {
    //     this.$message({
    //       message: '操作成功',
    //       type: 'success'
    //     });
    //   }).finally(error=>{
    //     this.init()
    //   })
    // },
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },

    // list
    init() {
      let data = {
        name: this.searchForm.name,
        code: this.searchForm.code,
        // page: this.currPage,
        // pageSize: this.pageSize,
      }
      this.axios
          .get("api/Cup", {params: data})
          .then((res) => {
            this.tableData = res.list
            this.total = res.count
          })
    }
  },
  mounted() {
    //
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.drugCup {

}
</style>